module.exports = __webpack_public_path__ + "static/img/yytx17.58bae7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx17.png
// module id = 889
// module chunks = 0